import { injectable } from "tsyringe";
import { BookingV4ApiRepository } from "@/app/infrastructures/repositories/api/BookingV4ApiRepository";
import {
  ManualBookingV4Retail,
  GetEstimationPriceV4,
  // GetBookingVoucherListV4,
  // ValidateBookingVoucherCodeV4,
  // IssueVoucherBookingOtpRequestV4,
  // CancelVoucherBookingReserveRequestV4,
  ProductConfigurationRuleRequestParamsV4,
  RequestListCommodityV4,
  ExchangeRateParamsV4,
  CorporateBookingV4Client
} from "@/data/payload/api/BookingV4Request";
import {
  PayloadPosterProduct,
  EstimationPrice,
  // BookingVoucherList,
  // BookingVoucherItem,
  PosterProduct
} from "@/domain/entities/Booking";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
// import { VoucherBookingOtp } from "@/domain/entities/Voucher";
import { ProductConfigurationRule } from "@/domain/entities/Product";
import { Commodity } from "@/domain/entities/Commodity";
import { Pagination } from "@/domain/entities/Pagination";
import { ExchangeRateBookingV4, SavedPackageBookingV4 } from "@/domain/entities/BookingV4";

// BookingV4Presenter — forward semua method ke repository (sama pattern CreateBookingV3Presenter/BookingPresenter)
@injectable()
export class BookingV4Presenter {
  private repository: BookingV4ApiRepository;

  constructor(repository: BookingV4ApiRepository) {
    this.repository = repository;
  }

  public addManualBooking(
    payload: ManualBookingV4Retail
  ): Promise<ResponsePayload> {
    return this.repository.addManualBooking(payload);
  }

  public addBookingCorporate(
    payload: CorporateBookingV4Client
  ): Promise<ResponsePayload> {
    return this.repository.addBookingCorporate(payload);
  }

  public getEstimationPrice(
    payload: GetEstimationPriceV4
  ): Promise<EstimationPrice> {
    return this.repository.getEstimationPrice(payload);
  }

  /*
  public getBookingVoucherList(
    payload: GetBookingVoucherListV4
  ): Promise<BookingVoucherList> {
    return this.repository.getBookingVoucherList(payload);
  }

  public validateBookingVoucherCode(
    payload: ValidateBookingVoucherCodeV4
  ): Promise<BookingVoucherItem> {
    return this.repository.validateBookingVoucherCode(payload);
  }

  public issueVoucherBookingOtp(
    payload: IssueVoucherBookingOtpRequestV4
  ): Promise<VoucherBookingOtp> {
    return this.repository.issueVoucherBookingOtp(payload);
  }

  public cancelVoucherBookingReserve(
    payload: CancelVoucherBookingReserveRequestV4
  ): Promise<boolean> {
    return this.repository.cancelVoucherBookingReserve(payload);
  }
  */

  public postToGetPosterProduct(
    payload: PayloadPosterProduct
  ): Promise<PosterProduct[]> {
    return this.repository.postToGetPosterProduct(payload);
  }

  public fetchProductConfigurationRule(
    params: ProductConfigurationRuleRequestParamsV4
  ): Promise<ProductConfigurationRule[]> {
    return this.repository.fetchProductConfigurationRule(params);
  }

  public getCommodityList(
    params: RequestListCommodityV4
  ): Promise<{ data: Commodity[]; pagination: Pagination }> {
    return this.repository.getCommodityList(params);
  }

  public getActiveExchangeRate(
    params: ExchangeRateParamsV4
  ): Promise<ExchangeRateBookingV4 | null> {
    return this.repository.getActiveExchangeRate(params);
  }

  public getSavedPackage(
    customerId: number
  ): Promise<SavedPackageBookingV4[]> {
    return this.repository.getSavedPackage(customerId);
  }

  public getSavedPackageDetail(
    customerId: number,
    packageId: number
  ): Promise<SavedPackageBookingV4> {
    return this.repository.getSavedPackageDetail(customerId, packageId);
  }
}
